import {
  Text,
  BorderRadius,
  Colors,
  Spacing,
} from '@doordash/design-language'
import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

type WarningBadgeProps = {
  styles: any
}

export const WarningBadge = styled(Text).attrs<WarningBadgeProps>({
  weight: Text.Weights.Bold,
  size: Text.Sizes.S12,
})`
  background-color: ${Colors.WarningBackground};
  border-radius: ${BorderRadius.Small}px;
  padding: ${Spacing.XxxSmall}px;
`
